module.exports = __webpack_public_path__ + "static/media/logo.438bf2c9.png";